import { Icon } from '../components/Icon';
import { BENEFITS } from '../content/site';

export function Benefits() {
  return (
    <section id="benefits" className="section bg-surface-alt">
      <div className="container-content">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Why partner with us</span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-ink-900 sm:text-4xl">
            Measurable engagement, not vanity promises
          </h2>
          <p className="mt-4 text-lg text-ink-500">
            We help brands drive measurable engagement, traffic and qualified opt-in interest —
            and we report on what actually happened.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {BENEFITS.map((benefit) => (
            <li key={benefit.title} className="rounded-2xl bg-white p-6 shadow-card">
              <span className="grid h-11 w-11 place-items-center rounded-xl bg-aurora text-white">
                <Icon name={benefit.icon} className="h-6 w-6" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-ink-900">{benefit.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-700">{benefit.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Benefits;
